/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types */
export type MonthIndex = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export function isMonthIndex(index: number): index is MonthIndex {
  return 1 <= index && index <= 12;
}
export interface WithTimestamps {
  created_at: string;
  updated_at: string;
}

export type Constructor = new (...args: any[]) => {};

type ParamsRecord = Record<string, number | string>;
interface NamedRoute {
  name: string;
  params?: ParamsRecord;
  query?: ParamsRecord;
}
export type RouterLinkTo = string | NamedRoute;
